module.exports = {"450423100":"蒙山镇","450423101":"西河镇","450423102":"新圩镇","450423103":"文圩镇","450423104":"黄村镇","450423105":"陈塘镇","450423200":"汉豪乡","450423201":"长坪瑶族乡","450423202":"夏宜瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450423.json
// module id = 2115
// module chunks = 0